export enum ProfilesEnum {
  ADMIN = '63G_ADMIN',
  EXPLOITANT_RESPONSABLE_SECURITE = '63G_DROIT-EXPLOITANT-RESPONSABLE-SECURITE',
  MANAGER = '63G_MANAGER',
  PILOTE = '63G_PILOTE',
  UTILISATEUR = '63G_UTILISATEUR',
  VISITEUR = 'VISITEUR'
}
